// extracted by mini-css-extract-plugin
module.exports = {"cellContainer":"cell-container___1j4ji","cell":"cell___1l28p","otherWrap":"other-wrap___94SSA","valueWrap":"value-wrap___MwigO","valueItem":"value-item___9U_yG"};